/**
 * Copyright (c) 2017-present, Tomaruba, Inc.
 * All rights reserved.
 *
 */
import { ReduceStore } from 'flux/utils'
import AppDispatcher from '../../core/AppDispatcher'
import TaskEvent from '../../event/TaskEvent'
import { Record } from 'immutable'
import PaginationParams from '../PagenationParams'

const TaskPaginationState = Record(PaginationParams)

class TaskPaginationStore extends ReduceStore {
  constructor() {
    super(AppDispatcher)
  }

  getInitialState() {
    return new TaskPaginationState()
  }

  reduce(state, action) {
    const payload = action.payload

    switch (action.type) {
      case TaskEvent.initialize:
        return state.clear()
      case TaskEvent.onSearch:
        return state.merge({
          page: payload.pagination.page,
          per_page: payload.pagination.per_page,
          total: payload.pagination.total
        })
    }

    return state
  }
}

export default new TaskPaginationStore()
